exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-storyblok-editor-tsx": () => import("./../../../src/pages/storyblok_editor.tsx" /* webpackChunkName: "component---src-pages-storyblok-editor-tsx" */),
  "component---src-templates-storyblok-js": () => import("./../../../src/templates/storyblok.js" /* webpackChunkName: "component---src-templates-storyblok-js" */)
}

